import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import SalesReportService from "../../../services/OrderingServices/SalesReportService";

const SalesReportDetail = ({ isOpen, toggle, selectedItem }) => {
  console.log("🚀 ~ SalesReportDetail ~ selectedItem:", selectedItem);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const orgInfo = user?.organizationInfo || {};
  const [responseData, setResponseData] = useState();
  const fetchDetail = async () => {
    try {
      const response = await SalesReportService.getDetail(
        selectedItem?.orderReferenceId
      );
      setResponseData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDetail();
  }, [selectedItem?.id]);
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody style={{ fontFamily: "monospace" }}>
        <div className="p-3">
          {/* Bill Header */}
          <div className="text-center mb-4">
            <h5 className="fw-bold text-uppercase mb-0 ">
              {orgInfo?.name || "Company Name"}
            </h5>
            <div className="text-uppercase">{orgInfo?.address1 || ""}</div>
            <div>{orgInfo?.tel || "000-0000000"}</div>
          </div>
          <div className="d-flex justify-content-between small mb-3">
            <div>
              <strong>Order Ref:</strong> {responseData?.orderReferenceId|| ""}
            </div>
            <div>
              <strong>Status:</strong> {responseData?.paymentStatus}
            </div>
          </div>

          {/* Order Table */}
          <Table size="sm" responsive className="table-bordered small mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th className="text-end">Price</th>
                <th className="text-center">Qty</th>
                <th className="text-end">Total</th>
              </tr>
            </thead>
            <tbody>
              {responseData?.orderDetails?.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.productName}</td>
                  <td className="text-end">{item.productPrice}</td>
                  <td className="text-center">{item.finalQuantity}</td>
                  <td className="text-end">
                    {item.productPrice * item.finalQuantity}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Bill Footer */}
          <div className="border-top pt-2 small">
            <div className="d-flex justify-content-between">
              <span>Subtotal</span>
              <span>{responseData?.totalAmount}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Discount</span>
              <span>{responseData?.discountAmount}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>Tax</span>
              <span>{responseData?.taxAmount}</span>
            </div>
            <hr className="m-1"/>
            <div className="d-flex justify-content-between fw-bold">
              <span>Grand Total</span>
              <span>{responseData?.grandTotal}</span>
            </div>
          </div>
        </div>
        <div className="small mt-2">
          <div className="text-center mt-2">**Thank You**</div>
          <div className="text-center text-muted small">
            Powered by Restro Order
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SalesReportDetail;
